module.exports = __webpack_public_path__ + "img/سه بعدی2.6d8f9aed.png";